import {createContext, useContext, useEffect, useState} from 'react';
import {getCurrentUser} from "../services/authService";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState({isRequest: true, error: null, data: null});

    const login = () => setIsAuthenticated(true);
    const logout = () => setIsAuthenticated(false);

    useEffect(() => {
        const currUser = getCurrentUser();

        setIsAuthenticated(!!currUser);
        setUser({...user, data: currUser, isRequest: false});

    }, []);

    const checkAuthentication = (user) => {
        setUser((prev) => ({...prev, data: user}));
        setIsAuthenticated(!!user);
    }

    return (
        <AuthContext.Provider
            value={{isAuthenticated, login, logout, user, setUser, setIsAuthenticated, checkAuthentication}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
